import $http from '@/libs/axios'

export default class InstagramPosterApi {
  static async processPost(data: any, accountId: any, postId?: any) {
    let url = `instagram/poster/${accountId}/process`
    if (postId) url += `/${postId}`
    return (await $http.post(url, data)).data
  }

  static async postNow(accountId: any, postId: any) {
    return (await $http.get(`instagram/poster/${accountId}/post-now/${postId}`)).data
  }

  static async postsList(accountId: any) {
    return (await $http.get(`instagram/poster/${accountId}/posts`)).data
  }

  static async fetchPost(accountId: any, mediaId: any) {
    return (await $http.get(`instagram/poster/${accountId}/post/${mediaId}`)).data
  }

  static async scheduledPostsList(accountId: any) {
    return (await $http.get(`instagram/poster/${accountId}/scheduled-posts`)).data
  }

  static async deletePost(accountId: any, postId: string) {
    return (await $http.delete(`instagram/poster/${accountId}/post/${postId}`)).data
  }
}
